import * as Sentry from '@sentry/browser';
import config from '../config';

if (config.sentry.enabled) {
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.sentry.environment,
    release: process.env.SENTRY_RELEASE,
  });
}
